export class TabsProvder {
  protected _id = 0;

  public tabsMeta: any[] = [];

  public active: number | null = null;

  toggleTab(id: number) {
    this.active = id;
  }

  renameTab(tabId, title) {
    for (const i in this.tabsMeta) {
      if (this.tabsMeta[i].id == tabId) {
        this.tabsMeta[i].title = title;
        return;
      }
    }
  }

  isActive(id: number): boolean {
    return this.active == id;
  }

  registerTab(title: string, tabEl: any): number {
    const id: number = ++this._id;
    this.tabsMeta.push({title, id, tabEl});
    if (!this.active) {
      this.toggleTab(id);
    }
    return id;
  }

  unregisterTab(tabId) {
    for (const i in this.tabsMeta) {
      if (this.tabsMeta[i].id == tabId) {
        this.tabsMeta.splice(+i, 1);
        this.refreshActive();
        return;
      }
    }
  }

  get activeTab() {
    for (const i in this.tabsMeta) {
      if (this.tabsMeta[i].id == this.active) {
        return this.tabsMeta[i];
      }
    }
    return null;
  }

  refreshActive() {
    if (!this.activeTab) this.active = this.tabsMeta.length > 0 ? this.tabsMeta[0].id : null;
  }
}
